import React from "react";
import { Trophy, Activity, Flame, BarChart3 } from "lucide-react";
import { GameStatusContext } from "../../providers/GameStatusProvider";

function StatItem({ icon, label, value }) {
  return (
    <div className="rounded-lg border border-border/70 bg-card/70 px-2 py-2.5 text-center min-h-[108px] flex flex-col items-center justify-center">
      <div className="min-h-[36px] flex items-center justify-center">
        <div className="flex items-center justify-center gap-1.5 text-[12px] leading-tight text-muted-foreground text-center">
          {icon}
          <span>{label}</span>
        </div>
      </div>
      <p className="mt-1 text-[30px] leading-none font-bold tracking-tight">{value}</p>
    </div>
  );
}

function GameStatsCard() {
  const { gameStats } = React.useContext(GameStatusContext);

  const played = gameStats?.played ?? 0;
  const wins = gameStats?.wins ?? 0;
  const winRate = played > 0 ? Math.round((wins / played) * 100) : 0;
  const avgMistakes =
    played > 0 ? (gameStats.totalMistakes / played).toFixed(1) : "0.0";
  const currentStreak = gameStats?.currentStreak ?? 0;
  const maxStreak = gameStats?.maxStreak ?? 0;

  return (
    <section className="w-full max-w-[500px] px-4">
      <div className="rounded-xl border border-border/80 bg-card/85 shadow-[0_8px_30px_rgba(15,23,42,0.08)] p-3.5 backdrop-blur-sm">
        <p className="text-sm font-semibold mb-2 text-center">Your Stats</p>
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
          <StatItem
            icon={<BarChart3 className="h-3.5 w-3.5" />}
            label="Played"
            value={played}
          />
          <StatItem
            icon={<Trophy className="h-3.5 w-3.5" />}
            label="Win Rate"
            value={`${winRate}%`}
          />
          <StatItem
            icon={<Activity className="h-3.5 w-3.5" />}
            label="Avg Mistakes"
            value={avgMistakes}
          />
          <StatItem
            icon={<Flame className="h-3.5 w-3.5" />}
            label="Current Streak"
            value={currentStreak}
          />
          <StatItem
            icon={<Flame className="h-3.5 w-3.5" />}
            label="Best Streak"
            value={maxStreak}
          />
        </div>
      </div>
    </section>
  );
}

export default GameStatsCard;
